import React, { useState, useEffect } from 'react'
import { Menubar } from 'primereact/menubar';
import { PrimeIcons } from 'primereact/api';
import './TopBar.css';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Dialog } from "primereact/dialog";
import Button from '../../shared-components/Button/custom-button';
import { checkOnCHangeData } from '../ProjectList/home-store/home-actions-creators';

const Topbar = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { currentSurveyID, onChangeDataFlag } = useSelector((state) => state.projectList);
  const [showUnsavedChangespopUp, setShowUnsavedChangespopUp] = useState(false);
  const [navigationText, setNavigationText] = useState('');

  const items = [
    {
      label: 'Home',
      icon: PrimeIcons.HOME,
      command: () => {
        if (!onChangeDataFlag) {
          history.push('/surveys/survey-lists');
        } else {
          setNavigationText('survey-lists');
          setShowUnsavedChangespopUp(true);
        }
      },
      disabled: false,
    },
    {
      label: 'Dashboard',
      icon: 'fa-solid fa-gauge',
      command: () => {
        if (!onChangeDataFlag) {
          history.push(`/surveys/edit-survey/${currentSurveyID}/dashboard`);
        } else {
          setNavigationText('dashboard');
          setShowUnsavedChangespopUp(true);
        }
      },
      disabled: currentSurveyID === null,
    },
    {
      label: 'Details',
      icon: PrimeIcons.LIST,
      command: () => {
        if (!onChangeDataFlag) {
          if (currentSurveyID === null) {
            history.push('/surveys/create-survey');
          } else {
            history.push(`/surveys/edit-survey/${currentSurveyID}`);
          }
        } else {
          if (currentSurveyID === null) {
            setNavigationText('create-survey');
          } else {
            setNavigationText('edit-survey');
          }
          setShowUnsavedChangespopUp(true);
        }
      },
      disabled: false,
    },
    {
      label: 'Design',
      icon: 'fa-regular fa-pencil',
      command: () => {
        if (!onChangeDataFlag) {
          history.push(`/surveys/edit-survey/${currentSurveyID}/design`);
        } else {
          setNavigationText('design');
          setShowUnsavedChangespopUp(true);
        }
      },
      disabled: currentSurveyID === null,
    },
    {
      label: 'Respondents',
      icon: PrimeIcons.USERS,
      command: () => {
        if (!onChangeDataFlag) {
          history.push(`/surveys/edit-survey/${currentSurveyID}/respondents`);
        } else {
          setNavigationText('respondents');
          setShowUnsavedChangespopUp(true);
        }
      },
      disabled: currentSurveyID === null,
    },
    {
      label: 'Invitation',
      icon: PrimeIcons.ENVELOPE,
      command: () => {
        if (!onChangeDataFlag) {
          history.push(`/surveys/edit-survey/${currentSurveyID}/invitation`);
        } else {
          setNavigationText('invitation');
          setShowUnsavedChangespopUp(true);
        }
      },
      disabled: currentSurveyID === null,
    },
    {
      label: 'Data',
      icon: PrimeIcons.DATABASE,
      command: () => {
        if (!onChangeDataFlag) {
          history.push(`/surveys/edit-survey/${currentSurveyID}/data`);
        } else {
          setNavigationText('data');
          setShowUnsavedChangespopUp(true);
        }
      },
      disabled: currentSurveyID === null,
    },
    {
      label: 'Documentation',
      icon: 'fa-thin fa-bookmark',
      command: () => {
        if (!onChangeDataFlag) {
          history.push(`/surveys/edit-survey/${currentSurveyID}/documentation`);
        } else {
          setNavigationText('documentation');
          setShowUnsavedChangespopUp(true);
        }
      },
      disabled: currentSurveyID === null,
    },
  ];


  const hideUnSavedChanges = () => {
    setShowUnsavedChangespopUp(false);
  }

  const unSavedChangesFooter = () => {
    return (
      <div>
        <Button name='yes' label="Yes" icon="pi pi-check" onClick={unSaveChangesConfirm} style={{  fontSize: '12px', padding: '6px 5px' }}/>
        <Button name='no' label="No" icon="pi pi-times" onClick={hideUnSavedChanges} className="p-button-secondary" style={{  fontSize: '12px', padding: '6px 5px' }}/>
      </div>
    );
  }
  const unSaveChangesConfirm = () => {
    if (navigationText === 'create-survey') {
      history.push('/surveys/create-survey');
    } else if (navigationText === 'edit-survey') {
      history.push(`/surveys/edit-survey/${currentSurveyID}`);
    } else if (navigationText === 'dashboard') {
      history.push(`/surveys/edit-survey/${currentSurveyID}/dashboard`);
    } else if (navigationText === 'survey-lists') {
      history.push('/surveys/survey-lists');
    } else if (navigationText === 'design') {
      history.push(`/surveys/edit-survey/${currentSurveyID}/design`);
    } else if (navigationText === 'respondents') {
      history.push(`/surveys/edit-survey/${currentSurveyID}/respondents`);
    } else if (navigationText === 'invitation') {
      history.push(`/surveys/edit-survey/${currentSurveyID}/invitation`);
    } else if (navigationText === 'data') {
      history.push(`/surveys/edit-survey/${currentSurveyID}/data`);
    } else if (navigationText === 'documentation') {
      history.push(`/surveys/edit-survey/${currentSurveyID}/documentation`);
    }

    dispatch(checkOnCHangeData(false));
    hideUnSavedChanges();
  };


  return (<>
    <div className="topbar">
      <Menubar model={items} />
    </div>
    <Dialog header={"Unsaved Changes"} visible={showUnsavedChangespopUp} style={{ width: '40vw' }}
      onHide={hideUnSavedChanges} footer={unSavedChangesFooter()}>
      <p><b>You have unsaved changes.Are you sure you want to proceed?</b><br /></p>
    </Dialog>
  </>
  );
};

export default Topbar;
